module.exports = __webpack_public_path__ + "media/score.63ce9ecd.wav";